import { ReactElement, useMemo } from 'react';
import { ButtonContained } from 'components/general';
import { CreateProjectDialog } from './create/dialog';
import { FormattedMessage } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';

import { getClientAdminPermission } from 'shared/domain/permissions/getClientAdminPermission';
import { useCurrentUser } from 'store/user';
import ForbiddenTooltip from 'components/general/ForbiddenTooltip/ForbiddenTooltip';
import { useCreateProject } from 'components/dataCreationForms/project/withCreateProject';
import { useOrganizations } from 'store/organizations';

export function CreateProjectButton(): ReactElement {
  const { openDialog } = useCreateProject();
  const { basePermissions } = useCurrentUser();
  const { organizationsMap } = useOrganizations();
  const clientIdMap = useMemo(() => {
    if (!basePermissions || !organizationsMap) {
      return;
    }
    return getClientAdminPermission(basePermissions, organizationsMap);
  }, [basePermissions, organizationsMap]);

  const reason = clientIdMap
    ? 'create_project_disabled_reason'
    : 'create_project_disabled_reason_no_clients';

  return (
    <>
      <ForbiddenTooltip
        visibleWhen={!clientIdMap?.size}
        reason={reason}
      >
        <ButtonContained
          onClick={() => openDialog({})}
          disabled={!clientIdMap?.size}
        >
          <FormattedMessage id={ProjectSetupTranslationKeys.createProject} />
        </ButtonContained>
      </ForbiddenTooltip>
      <CreateProjectDialog />
    </>
  );
}
